var _excluded = ["unavailable", "disabled", "href", "children", "onClick"];
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import InlineLink from 'next/link';
import { forwardRef } from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "vpvb3j",
  styles: "cursor:not-allowed !important"
} : {
  name: "ak71kz-Link",
  styles: "cursor:not-allowed !important;label:Link;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export var Link = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var unavailable = _ref.unavailable,
    disabled = _ref.disabled,
    href = _ref.href,
    children = _ref.children,
    onClick = _ref.onClick,
    props = _objectWithoutProperties(_ref, _excluded);
  var handleClick = function handleClick(e) {
    if (disabled) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    onClick === null || onClick === void 0 || onClick(e);
  };
  if (unavailable) return ___EmotionJSX("a", _extends({
    ref: ref
  }, props, {
    onClick: handleClick
  }), children);
  if (disabled) return ___EmotionJSX("a", _extends({
    ref: ref
  }, props, {
    css: _ref2,
    onClick: handleClick
  }), children);
  return ___EmotionJSX(InlineLink, _extends({
    ref: ref,
    href: href
  }, props, {
    onClick: handleClick
  }), children);
});